import {
	NgModule,
	Optional,
	SkipSelf,
	ModuleWithProviders
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { NotificationComponent } from "./notification/notification.component";
import {
	MatCardModule,
	MatButtonModule,
	MatCommonModule,
	MatProgressSpinnerModule,
	MatIconModule
} from "@angular/material";
import { NotificationContainerComponent } from "./notification-container/notification-container.component";
import { NotificationIconComponent } from "./notification-icon/notification-icon.component";
import { NotificationConfig } from "./notification.config";
import { NotificationService } from "./notifications.service";

@NgModule({
	imports: [
		CommonModule,
		MatCommonModule,
		MatCardModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatIconModule
	],
	declarations: [
		NotificationComponent,
		NotificationContainerComponent,
		NotificationIconComponent
	],
	exports: [NotificationContainerComponent]
})
export class TryCatchNotificationsModule {
	constructor(
		@Optional()
		@SkipSelf()
		parentModule: TryCatchNotificationsModule
	) {
		if (parentModule) {
			throw new Error(
				"TryCatchNotificationsModule is already loaded. Import it in the AppModule only"
			);
		}
	}

	static forRoot(config: NotificationConfig): ModuleWithProviders {
		return {
			ngModule: TryCatchNotificationsModule,
			providers: [
				{ provide: NotificationConfig, useValue: config },
				NotificationService
			]
		};
	}
}
